import { defineComponent as _defineComponent } from 'vue'
import { ArrowLeft, Map } from "lucide-vue-next";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerNavbar',
  props: {
    logoUrl: {},
    brandText: {},
    showMap: { type: Boolean }
  },
  emits: ["back", "mapClick"],
  setup(__props: any, { expose: __expose }) {
  __expose();

  

  

const __returned__ = { get ArrowLeft() { return ArrowLeft }, get Map() { return Map } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})